import { render } from "./IconGasketSet.vue?vue&type=template&id=7ee84a42&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconGasketSet.vue?vue&type=script&lang=js"
export * from "./IconGasketSet.vue?vue&type=script&lang=js"
script.render = render

export default script